// API для проверки мессенджеров

export interface MessengerCheckResponse {
  success: boolean;
  found: boolean;
  message: string;
  user_info?: {
    first_name?: string;
    last_name?: string;
    username?: string;
    user_id?: number;
    status?: string;
    premium?: boolean;
    verified?: boolean;
  };
  display_message?: string;
}

// Проверка номера в Telegram
export const checkTelegram = async (phone: string): Promise<MessengerCheckResponse> => {
  try {
    const response = await fetch('/api/check_telegram', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phone }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка при проверке Telegram:', error);
    return {
      success: false,
      found: false,
      message: `❌ Ошибка при проверке: ${error instanceof Error ? error.message : 'Неизвестная ошибка'}`
    };
  }
};

// Проверка номера в WhatsApp
export const checkWhatsApp = async (phone: string): Promise<MessengerCheckResponse> => {
  try {
    const response = await fetch('/api/check_whatsapp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phone }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка при проверке WhatsApp:', error);
    return {
      success: false,
      found: false,
      message: `❌ Ошибка при проверке: ${error instanceof Error ? error.message : 'Неизвестная ошибка'}`
    };
  }
};
